import { useData } from "./util/dataProvider";
import { useState } from "react";
import { Route, Routes } from "react-router-dom";
import "./app.scss";
import Map from "./components/Map";
import Unternehmen from "./components/Unternehmen";
import Experten from "./components/Experten";
import Company from "./components/Company";
import Expert from "./components/Expert";

import Footer from "./components/Footer";
import Filter from "./components/Filter";
function App() {
    const { unternehmen, experten } = useData();
    const [active, setActive] = useState("all");
    return (
        <Routes>
            <Route path='/company/:companyid' element={<Company />} />
            <Route path='/expert/:expertid' element={<Expert />} />

            <Route
                path='/'
                exact
                element={
                    <div>
                        <Map active={active} />

                        <Filter active={active} setActive={setActive} />
                        {active === "all" && (
                            <>
                                <Unternehmen field={"all"} />
                                <Experten />
                            </>
                        )}
                        {active === "forschung" && (
                            <Unternehmen field={"forschung"} />
                        )}
                        {active === "startup" && (
                            <Unternehmen field={"startup"} />
                        )}

                        {active === "unternehmen" && (
                            <Unternehmen field={"all"} />
                        )}
                        {active === "experten" && <Experten active={active} />}
                        <Footer />
                    </div>
                }
            />
        </Routes>
    );
}

export default App;
